import { GetCookie } from '../customHook/useCookies'
import { jwtDecode } from 'jwt-decode'

export interface CurrentUserInterface {
  avatar: string
  code: string
  departmentId: number
  email: string
  exp: number
  fullName: string
  locationId: number
  role: number
  status: string
  username: string
}

export const getCurrentUser = (): CurrentUserInterface | null => {
  try {
    const accessToken = GetCookie('token')
    if (!accessToken) {
      return null
    }

    return jwtDecode<CurrentUserInterface>(accessToken)
  } catch (error) {
    return null
  }
}
